<template>
  <Stack
    tag="article"
    align="center"
    justify="start"
    class="py-md my-sm md:mt-none md:pt-none h-[400px] md:h-[500px] max-w-[600px] m-auto"
    direction="col"
    :breakpoints="{ justify: { md: 'center' } }"
    gap="md"
    data-test-id="plpNoResults"
    data-fs="plpNoResults"
  >
    <SvgIcon
      name="product-search"
      svg-class="h-[64px] w-[64px]"
      class="text-mkm-blue-light"
      :width="64"
      :height="64"
      :color="getColor('mkm-blue-default')"
    />

    <Stack v-if="hasRealFilters" tag="div" direction="col" gap="xs">
      <Heading size="lg" class="text-center">Oops!</Heading>
      <Text size="md" weight="bold" class="text-center">
        Looks like we don't have anything that matches your search.
      </Text>
      <Text size="md" class="text-center">
        Try removing some of the applied filters above to reveal more products.
      </Text>
    </Stack>

    <section v-else-if="isDynamicCategory()">
      <Stack v-if="!selectedBranch" tag="div" direction="col" gap="xs">
        <Text size="3xl" align="center" weight="bold" data-test-id="select-branch-msg !font-lg "
          >Please select a branch</Text
        >
        <Text class="text-center" weight="bold">To be able to see {{ categoryName }} near to you</Text>
        <button @click="setNearestBranchTray" class="text-mkm-blue-light mx-auto" data-test-id="find-branch-btn">
          Find nearest branch
        </button>
      </Stack>
      <section v-else tag="div" direction="col" gap="xs">
        <Heading size="lg" class="text-center">Sorry!</Heading>
        <Text size="md" weight="bold" class="text-center">
          No {{ categoryName }} are available to purchase online from {{ selectedBranch?.name }} right now.
        </Text>
      </section>
    </section>

    <section v-else>
      <Stack tag="div" direction="col" gap="xs">
        <Heading size="lg" class="text-center">Oops!</Heading>
        <Text size="md" weight="bold" class="text-center">
          {{ bigCommerceCategory?.name }} are not available to purchase online from {{ selectedBranch?.name }}
        </Text>
        <Text class="text-center"
          >Don't worry though, give the branch a call on
          <NuxtLink
            :to="`tel:${selectedBranch?.contacts?.phone}`"
            class="text-mkm-blue-light font-semibold"
            :aria-label="`Call ${selectedBranch?.name}`"
            >{{ selectedBranch?.contacts?.phone }}</NuxtLink
          >
          to find out about availability.</Text
        >
      </Stack>
    </section>
  </Stack>

  <LazyNearestBranchTray :include-coming-soon-branches="false" @update:branch="selectBranch(Number($event.branchId))" />
</template>

<script setup lang="ts">
import { getColor } from "mkm-avengers";

const route = useRoute();
const { selectedBranch, selectBranch } = useBranches();
const { bigCommerceCategory } = useCategory();
const { setNearestBranchTray } = useUIState();

const hasRealFilters = computed(() => {
  const query = route.query;

  return Object.keys(query).some((key) => {
    return key !== "branch" && !key.startsWith("sort");
  });
});

const categoryName = computed(
  () => `${bigCommerceCategory.value.name} ${bigCommerceCategory.value.name === "Clearance" ? "items" : ""}`,
);
</script>
